export default __webpack_public_path__ + "static/project-slide-7-4032-2268-562363cd9ef428c5b2377657f906bb58.webp";